import React, { Component } from 'react';
import { ImagePicker } from 'react-file-picker'

import './css/ClosedQuestion.css';
import StringUtils from "../../utils/StringUtils";

class ClosedQuestion extends Component {

    componentWillMount() {
        this.selectedCheckboxes = new Set();
        this.selectedRadio = '';

        const answers = this.props.answers.slice(0);
        const answerImages = this.props.answers.slice(0);
        const checked = new Array(answers.length).fill(false);

        for (let i = 0; i < answers.length; i++) {
            answerImages[i] = StringUtils.getLastImage(answerImages[i]);
            answers[i] = StringUtils.removeImage(answers[i]);

            if (this.props.multipleChoice && this.props.correctAnswers.includes(answers[i])) {
                checked[i] = true;
            } else if (this.props.correctAnswers === answers[i]) {
                checked[i] = true;
            }
        }

        const question = StringUtils.removeImage(this.props.question);
        const questionImage = StringUtils.getLastImage(this.props.question);

        this.setState({
            checked: checked,
            answers: answers,
            answerImages: answerImages,
            question: question,
            questionImage: questionImage,
            multipleChoice: this.props.multipleChoice || false,
            shuffle: this.props.shuffle || false
        });
    }

    handleChange = (label, number) => {
        let checked = this.state.checked;
        if (this.state.multipleChoice) {
            checked[number] = !checked[number];
        } else {
            checked = new Array(this.props.answers.length).fill(false);
            checked[number] = true;
        }

        this.setState({ checked: checked }, () => {
            this.refreshCheckboxesState();
            this.saveCheckboxesState();
        });
    };

    refreshCheckboxesState = () => {
        const checked = this.state.checked;
        this.selectedCheckboxes.clear();
        for (let i = 0; i < checked.length; i++) {
            if (checked[i]) {
                const value = StringUtils.createTextWithImg(this.state.answers[i], this.state.answerImages[i]);
                this.selectedCheckboxes.add(value);
                this.selectedRadio = value;
            }
        }
    };

    saveCheckboxesState = () => {
        if (this.state.multipleChoice) {
            this.props.saveAnswer(this.props.id, Array.from(this.selectedCheckboxes));
        } else {
            this.props.saveAnswer(this.props.id, this.selectedRadio);
        }
    };

    setAnswer = (number, event) => {
        const answers = this.state.answers;
        answers[number] = event.target.value;
        this.setState({ answers: answers }, () => {
            this.refreshCheckboxesState();
            this.saveCheckboxesState();
        });
        this.props.setAnswers(this.props.id, answers);
    };

    addAnswer = () => {
        const answers = this.state.answers;
        answers.push('');
        this.setState({ answers: answers });
    };

    removeAnswer = (number) => {
        const answers = this.state.answers;
        answers.splice(number, 1);
        this.setState({ answers: answers });
        this.props.setAnswers(this.props.id, answers);
    };

    handleTypeChange = () => {
        const checked = new Array(this.props.answers.length).fill(false);
        const multipleChoice = !this.props.multipleChoice;
        this.setState({ checked: checked, multipleChoice: multipleChoice });
        this.props.setMultipleChoice(this.props.id, multipleChoice);
        this.props.saveAnswer(this.props.id, multipleChoice ? [] : '');
    };

    handleShuffleChange = () => {
        const shuffle = !this.state.shuffle;
        this.setState({ shuffle: shuffle });
        this.props.setShuffle(this.props.id, shuffle);
    };

    setQuestion = (event) => {
        const question = event.target.value;
        this.setState({ question: question });
        this.props.setQuestion(this.props.id, StringUtils.createTextWithImg(question, this.state.questionImage));
    };

    removeQuestionImage = () => {
        this.setState({ questionImage: null });
        this.props.setQuestion(this.props.id, this.props.question);
    };

    setImage = (answerNumber, base64EncodedString) => {
        const images = this.state.answerImages;
        images[answerNumber] = base64EncodedString;
        this.setState({ answerImages: images }, () => {
            this.refreshCheckboxesState();
            this.saveCheckboxesState();
        });
    };

    removeImage = (answerNumber) => {
        const images = this.state.answerImages;
        images[answerNumber] = null;
        this.setState({ answerImages: images }, () => {
            this.refreshCheckboxesState();
            this.saveCheckboxesState();
        });
    };

    deleteQuestion = () => {
        const userIsSure = window.confirm("Na pewno?");
        if (userIsSure) {
            this.props.deleteQuestion(this.props.id);
        }
    };

    render() {
        let i = 1;
        const type = this.props.multipleChoice ? "checkbox" : "radio";
        const containerClass = type + "-container";
        const checked = this.state.checked;
        const answers = this.state.answers.map(answer => {
            const answerKey = "answer-" + this.props.id + "-" + i;
            const answerNumber = i - 1;
            const image = this.state.answerImages[answerNumber];
            i += 1;
            return (
                <label key={answerKey} className={"answer " + containerClass}>
                    <input type={type}
                           name={"answer-" + this.props.id}
                           id={answerKey}
                           value={answer}
                           checked={checked[answerNumber]}
                           onChange={() => this.handleChange(answer, answerNumber)}
                    />
                    <span className="checkmark" />
                    <label htmlFor={answerKey}>
                        <input type="text" value={answer} className="answer-value" onChange={(event) => this.setAnswer(answerNumber, event)} />
                        {image != null ? <img src={image} alt="external" className="external-image" /> : ''}
                        <ImagePicker
                            extensions={['jpg', 'jpeg', 'png']}
                            dims={{ minWidth: 100, minHeight: 100 }}
                            onChange={base64EncodedString => this.setImage(answerNumber, base64EncodedString)}
                            onError={errMsg => console.log(errMsg)}
                            style={{ display: "inline-block" }}
                        >
                            <button className="btn-square"><i className="far fa-image" /></button>
                        </ImagePicker>
                        {image != null ? <button className="btn-square" onClick={() => this.removeImage(answerNumber)}><i className="fas fa-ban" /></button> : ''}
                        <button className="btn-square" onClick={() => this.removeAnswer(answerNumber)}><i className="far fa-trash-alt" /></button>
                    </label>
                </label>);
            }
        );

        const questionImage = (<img alt="external" className="external-image" src={this.state.questionImage} />);

        return (
            <div className="task-block closed-question-edit">
                {this.props.isFirst ? '' : <button className="btn-square" onClick={this.props.moveUp}><i className="fas fa-arrow-up"></i></button>}
                {this.props.isLast ? '' : <button className="btn-square" onClick={this.props.moveDown}><i className="fas fa-arrow-down"></i></button>}
                <div className="question-number">Pytanie {this.props.number} (1 pkt)</div>
                <div className="question">
                    <input type="text" placeholder="Pytanie" value={this.state.question} className="question-value" onChange={this.setQuestion} />
                    {this.state.questionImage != null ? questionImage : ''}
                    <ImagePicker
                        extensions={['jpg', 'jpeg', 'png']}
                        dims={{ minWidth: 100, minHeight: 100 }}
                        onChange={base64EncodedString => this.setState({ questionImage: base64EncodedString })}
                        onError={errMsg => console.log(errMsg)}
                        style={{ display: "inline-block" }}
                    >
                        <button className="btn-square"><i className="far fa-image" /></button>
                    </ImagePicker>
                    {this.state.questionImage != null ? <button className="btn-square" onClick={this.removeQuestionImage}><i className="fas fa-ban" /></button> : ''}
                    <button className="btn-square" onClick={this.deleteQuestion}><i className="far fa-trash-alt" /></button>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input type="checkbox" onChange={this.handleTypeChange} checked={this.props.multipleChoice} />
                        <span className="checkmark"/>
                        <label>
                            Wielokrotny wybór
                        </label>
                    </label>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input type="checkbox" onChange={this.handleShuffleChange} checked={this.state.shuffle} />
                        <span className="checkmark"/>
                        <label>
                            Losowa kolejność
                        </label>
                    </label>
                </div>
                <fieldset id={"group-" + this.props.id}>
                    {answers}
                    <button className="btn-square" onClick={this.addAnswer}><i className="fas fa-plus" /></button>
                </fieldset>
            </div>
        );
    }
}

export default ClosedQuestion;